import { useField } from 'formik';
import { Typography } from '@mui/material';
import { Select } from 'gf-ui-components-mui-lib';
import { Downarr } from '@/icons';

interface ISelectWrapper {
  label?: string;
  name: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  options?: any;
  disabled?: boolean;
  errors?: boolean;
}

const Menustyle = {
  borderRadius: '9px',
  border: '1px solid rgba(191, 191, 191, 0.25)',
  background: ' #FFF',
  boxShadow: '0px 12px 24px 0px rgba(0, 0, 0, 0.15)',
  padding: '0px 16px',
  paddingBottom: '6px',
  '& .MuiMenuItem-root': {
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '22px',
    marginTop: '6px',
  },
};
const SelectWrapper = (props: ISelectWrapper) => {
  const [field, meta] = useField(props);
  const selectStyles = {
    color: props.disabled ? 'var(--gray-500, #667085)' : '#000',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    minwidth: '100%',
    height: '50px',
    borderRadius: '8px',
    paddingTop: '5px',
    '& .MuiSelect-outlined': {
      color: props.disabled ? 'var(--gray-500, #667085)' : '#000',
    },
    background: props.disabled ? 'var(--gray-050, #FAFAFA)' : 'white',
    '& .MuiOutlinedInput-root:hover fieldset': {
      border: meta.error && (meta.touched || props.errors) ? '1px solid #F27A7A' : '1px solid #D0D5DD',
    },
    '& .MuiOutlinedInput-root.Mui-focused fieldset': {
      boxShadow: '0px 0.9999999403953552px 0px 0px rgba(16, 24, 40, 0.05)',
      borderRadius: '8px',
      borderTopRightRadius: '0px',
      borderBottomRightRadius: '0px',
      border: meta.error && (meta.touched || props.errors) ? '1px solid #F27A7A' : '1px solid #D0D5DD',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: meta.error && (meta.touched || props.errors) ? '1px solid #F27A7A' : '1px solid #D0D5DD',
    },
    boxShadow: '0px 0.9999999403953552px 1.9999998807907104px 0px rgba(16, 24, 40, 0.05)',
    svg: {
      marginRight: '20px',
      cursor: 'pointer',
      marginBottom: '3px',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: meta.error && (meta.touched || props.errors) ? '1px solid #F27A7A' : '1px solid #D0D5DD',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: meta.error && (meta.touched || props.errors) ? '1px solid #F27A7A' : '1px solid #D0D5DD',
    },
  };
  return (
    <>
      {props?.label && (
        <Typography
          sx={{
            color: '#344054',
            fontSize: 14,
            fontFamily: 'Inter',
            fontWeight: '500',
            lineHeight: ' 20px',
            wordWrap: 'break-word',
          }}
          className="list-count"
        >
          {props.label}
        </Typography>
      )}
      <Select
        options={
          props.options?.length > 0
            ? [{ label: 'Select', value: 0 }, ...props.options]
            : [{ label: 'Select', value: 0 }]
        }
        Listselect={true}
        Icon={<Downarr />}
        sx={selectStyles}
        Menustyle={Menustyle}
        {...field}
        {...(props.onChange && { onChange: props.onChange })}
        className={`input-select input-select${meta.error && (meta.touched || props.errors) ? '' : '-def-input'}`}
      />
      {meta.error && (meta.touched || props.errors) && (
        <Typography sx={{ fontSize: '10px', color: '#F27A7A', fontFamily: 'Poppins', lineHeight: '16px' }}>
          {meta.error}
        </Typography>
      )}
    </>
  );
};
export default SelectWrapper;
